/* Label Naveli — reveal-on-scroll + small touches. No dependencies. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('nv-js');
  window.__nvReady = true;

  function markHorizonSections(scope) {
    (scope || document).querySelectorAll('#MainContent > .shopify-section').forEach(function (s, i) {
      if (i === 0) return;
      if (!s.querySelector('[data-nv-reveal]')) s.classList.add('nv-auto-reveal');
    });
  }

  function stagger(scope) {
    (scope || document).querySelectorAll('[data-nv-stagger]').forEach(function (group) {
      var step = parseFloat(group.getAttribute('data-nv-stagger')) || 0.08;
      Array.prototype.forEach.call(group.children, function (el, i) {
        if (el.hasAttribute('data-nv-reveal')) el.style.setProperty('--nv-delay', Math.min(i * step, 0.6).toFixed(2) + 's');
      });
    });
  }

  var io = null;
  function observe(scope) {
    var els = (scope || document).querySelectorAll('[data-nv-reveal]:not(.is-visible), .nv-auto-reveal:not(.is-visible), .nv-ornament:not(.is-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function parallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-nv-parallax]');
    if (!items.length || window.matchMedia('(max-width: 749px)').matches) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -24).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function slideshow(scope) {
    (scope || document).querySelectorAll('[data-nv-slides]').forEach(function (wrap) {
      if (wrap.__nv) return; wrap.__nv = true;
      var slides = wrap.querySelectorAll('.nv-hero__slide');
      var dots = wrap.querySelectorAll('.nv-hero__dot');
      if (slides.length < 2) return;
      var i = 0, timer, delay = (parseInt(wrap.getAttribute('data-nv-slides'), 10) || 6) * 1000;
      function go(n) {
        slides[i].classList.remove('is-active'); slides[i].setAttribute('tabindex', '-1'); if (dots[i]) dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); slides[i].removeAttribute('tabindex'); if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      }
      function stop() { clearInterval(timer); }
      function play() { if (reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, delay); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      var x0 = null;
      wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      });
      wrap.addEventListener('mouseenter', stop); wrap.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { play(); } });
      play();
    });
  }

  function waHint() {
    var wa = document.querySelector('.nv-wa');
    if (!wa) return;
    try { if (sessionStorage.getItem('nv-wa-hint')) return; } catch (e) {}
    setTimeout(function () {
      wa.classList.add('is-hinting');
      setTimeout(function () { wa.classList.remove('is-hinting'); }, 4500);
      try { sessionStorage.setItem('nv-wa-hint', '1'); } catch (e) {}
    }, 5000);
  }

  function init(scope) { markHorizonSections(); stagger(scope); observe(scope); slideshow(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); parallax(); waHint(); });
  } else { init(); parallax(); waHint(); }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('[data-nv-reveal], .nv-ornament, .nv-auto-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    e.target.classList.add('is-visible');
  });
})();
